<div class="container-fluid mt-5">
  <div class="flex justify-between items-center mb-3 -mt-5 w-full">

  <!-- LEFT SIDE: TITLE -->
  <div>
    <h3 class="m-0 text-xl font-semibold">Packages</h3>
    <p class="text-gray-500 text-sm mt-1">Manage product catalog and pricing</p>
  </div>

  <!-- RIGHT SIDE: SEARCH + BUTTON -->
  <div class="flex items-center gap-3">

    <!-- SEARCH BAR -->
    <div class="flex items-center gap-2 border rounded-lg px-3 py-2 bg-white">
      <i class="pi pi-search text-gray-500"></i>
      <input 
        pInputText 
        [(ngModel)]="searchText" 
        placeholder="Search packages..." 
        class="outline-none border-none p-0"
      />
    </div>

    <!-- ADD PACKAGE BUTTON -->
    <p-button 
      label="New Package" 
      icon="pi pi-plus" 
      (onClick)="openCreatePackage()">
    </p-button>

  </div>

</div>
  <p-table [value]="filterPackages()" [loading]="loading" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-striped">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="package_name">
          Name <p-sortIcon field="package_name"></p-sortIcon>
        </th>
        <th pSortableColumn="price">
          Price (mo) <p-sortIcon field="price"></p-sortIcon>
        </th>
        <th>Features/Limits</th>
        <th pSortableColumn="billing_cycle">
          Billing <p-sortIcon field="billing_cycle"></p-sortIcon>
        </th>
        <th>Status</th>
        <th style="width: 120px;">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-package>
      <tr>
        <td>
          <div class="font-semibold">{{ package.package_name }}</div>
          <div class="text-sm text-gray-500" *ngIf="package.description">{{ package.description }}</div>
        </td>
        <td>
          <span class="font-semibold text-primary">₹{{ getPrice(package) }}</span>
        </td>
        <td>
          <span class="text-sm text-gray-600">{{ getFeaturesSummary(package.features) }}</span>
        </td>
        <td>
          <span class="text-capitalize">{{ package.billing_cycle || 'Monthly' }}</span>
        </td>
        <td>
          <span class="px-2 py-1 border-round text-xs font-semibold"
            [ngClass]="package.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
            {{ package.status || 'Active' }}
          </span>
        </td>
        <td>
          <div class="flex gap-2">
            <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" severity="secondary"
              (onClick)="onEdit(package)" pTooltip="Edit">
            </p-button>
            <p-button icon="pi pi-trash" [text]="true" [rounded]="true" severity="danger" (onClick)="onDelete(package)"
              pTooltip="Delete">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center py-4">
          <i class="pi pi-inbox text-4xl text-gray-400 mb-3"></i>
          <p class="text-gray-500">No packages found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>



